<template>
    <div class="out-box">
        <label class="show-img do-business">
            <img v-if="picShow" :src="imgShow" alt="">
        </label>
        <div class="img-preview" @click="openImgPreview" v-if="picShow">
            预览
        </div>
        <el-dialog
                :title="backgroundTypeTransformation(backgroundType)"
                :visible.sync="centerDialogVisible"
                width="50%"
                height="60%"
                center>
            <span style="display: flex;align-items: center;justify-content: center">
                 <img ref="rotateImg" v-if="picShow" :src="imgShow" style="width: 90%" alt="">
            </span>
            <div style="display: flex;align-items: center;justify-content: space-between">
                <el-button @click="rotate(0)">左旋转</el-button>
                <el-button @click="rotate(1)">右旋转</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        props:{
            backgroundType: {
                type: Number,
            },
            imgUrl: {
                type: String,
            },
        },
        data(){
            return {
                picShow:false,
                centerDialogVisible:false,
                imgShow:'',
                fileInfo:{
                    deg:0
                }
            }
        },
        mounted(){
            this.getImgUrl(this.imgUrl);
        },
        methods:{
            //获取图片
            getImgUrl(filePath){
                this.$http({
                    method: 'get',
                    url: '/portal/downfile?filePath=' + filePath,
                    responseType: 'blob'
                }).then(res => {
                    var typeName = filePath.split(".")[1];
                    let blob = new Blob([res.data], {type: 'application/' + typeName + ''})
                    this.imgShow = window.URL.createObjectURL(blob);
                    this.picShow = true;
                })
            },
            //预览图片
            openImgPreview(){
                this.centerDialogVisible = true;
            },
            //backgroundType 图片上传组件背景参数 1-> 营业执照 2-> 身份证正面 3-> 身份证反面 4-> 基本户扫描件 5-> 资质证书
            backgroundTypeTransformation(val){
                switch(val){
                    case 1 : return '营业执照' ; break;
                    case 2 : return '身份证正面' ; break;
                    case 3 : return '身份证反面' ; break;
                    case 4 : return '基本户扫描件' ; break;
                    case 5 : return '资质证书' ; break;
                    default : return '' ; break;
                }
            },
            rotate (val) {
                if(val == 0){
                    console.log('left')
                    this.fileInfo.deg -= 90;
                    if (this.fileInfo.deg <= -360) {
                        this.fileInfo.deg = 0
                    }
                }else{
                    this.fileInfo.deg += 90;
                    if (this.fileInfo.deg >= 360) {
                        this.fileInfo.deg = 0
                    }

                }
                this.$refs.rotateImg.style.transform = `rotate(${this.fileInfo.deg}deg)`;
                this.$refs.rotateImg.style.width = '70%';
                this.$refs.rotateImg.style.height = '70%';
            }
        }
    }
</script>
<style lang="scss" scoped>
    .out-box {
        width: 300px;
        height: 186px;
        position: relative;
        margin: 0 0 48px 0;
        .show-img {
            display: inline-block;
            width: 100%;
            height: 100%;
            cursor: pointer;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .img-preview{
            width: 50px;
            position: absolute;
            left: 270px;
            bottom: -40px;
            font-size: 14px;
            color: #1890FF;
            cursor: pointer;
        }
    }
    @media screen and (max-width: 1600px){
        .out-box{
            width: 240px;
            .show-img{
                width: 200px;
                height: 140px;
            }
            .img-preview{
                left: 170px;
            }
        }
    }
</style>